import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { API, errMsg } from "@/lib/api";

export default function SignUpPage() {
  const [params] = useSearchParams();
  const token = params.get("invite");
  const [invite, setInvite] = useState(null);
  const [inviteErr, setInviteErr] = useState("");
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!token) return;
    axios.get(`${API}/auth/invite/${token}`)
      .then((r) => { setInvite(r.data); setEmail(r.data.email); })
      .catch((e) => setInviteErr(`${errMsg(e)}.`));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (pw !== pw2) return setError("The passwords don't match");
    if (pw.length < 15) return setError("Use at least 15 characters for the password");
    setBusy(true);
    try {
      const r = await axios.post(`${API}/auth/register`, { email, password: pw, invite_token: invite ? token : null });
      window.location.assign(`/sign-in?__clerk_ticket=${encodeURIComponent(r.data.ticket)}`);
    } catch (err) {
      const msg = errMsg(err);
      if (invite && /taken/i.test(msg)) {
        localStorage.setItem("pending_invite", token);
        setError("You already have a login with this email. Sign in and you'll be added to the firm.");
      } else setError(msg);
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} className="w-full max-w-sm bg-white border border-slate-200 p-8 space-y-4" data-testid="signup-form">
      <div>
        <h1 className="font-serif text-3xl text-slate-900">Create your login</h1>
        <p className="text-sm text-slate-500 mt-1" data-testid="signup-context">
          {invite ? (invite.role === "client" ? `Create your private login to view the statement books ${invite.firm_name} shares with you.` : `You're joining ${invite.firm_name} as ${invite.role}.`) : "No confirmation code needed."}
        </p>
        {inviteErr && <p className="text-sm text-amber-700 mt-2" data-testid="signup-invite-error">{inviteErr} You can still create a login.</p>}
      </div>
      <div className="space-y-1.5">
        <label className="small-label" htmlFor="su-email">Email</label>
        <Input id="su-email" type="email" required value={email} disabled={!!invite} onChange={(e) => setEmail(e.target.value)} className="rounded-sm" data-testid="signup-email-input" />
      </div>
      <div className="space-y-1.5">
        <label className="small-label" htmlFor="su-pw">Password (15+ characters)</label>
        <Input id="su-pw" type="password" required value={pw} onChange={(e) => setPw(e.target.value)} className="rounded-sm" data-testid="signup-password-input" />
      </div>
      <div className="space-y-1.5">
        <label className="small-label" htmlFor="su-pw2">Confirm password</label>
        <Input id="su-pw2" type="password" required value={pw2} onChange={(e) => setPw2(e.target.value)} className="rounded-sm" data-testid="signup-password-confirm-input" />
      </div>
      {error && <p className="text-sm text-red-700" data-testid="signup-error">{error}</p>}
      <Button type="submit" disabled={busy} className="w-full rounded-sm h-11" data-testid="signup-submit-button">{busy ? "Creating…" : "Create login"}</Button>
      <p className="text-sm text-slate-500 text-center">Already have a login? <Link to="/sign-in" className="underline" data-testid="signup-signin-link">Sign in</Link></p>
    </form>
  );
}
